import { render } from "./AddNoticeView.vue?vue&type=template&id=2837d1f8&scoped=true"
import script from "./AddNoticeView.vue?vue&type=script&lang=js"
export * from "./AddNoticeView.vue?vue&type=script&lang=js"

import "./AddNoticeView.vue?vue&type=style&index=0&id=2837d1f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2837d1f8"]])

export default __exports__